









































import { Mixins, Component, Prop, Emit } from "vue-property-decorator";
import { ReceptionDetail, ReceptionComment, ReceptionCommentSet } from "../../../../domain/workflow/reception";
import { ReceptionCommentKinds, ReceptionCommentKindsName } from "../../../../domain/workflow/kinds";
import { ModelEditableMixin } from "../../../system/mixins";
import ReceptionDetailCommentEditor from "./ReceptionDetailCommentEditor.vue";

@Component({
  components: {
    ReceptionDetailCommentEditor,
  }
})
export default class ReceptionDetailCommentsEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: ReceptionDetail) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ReceptionDetail) => T, defaultValue: T) => T;

  @Prop()
  isRegistered: boolean;

  @Prop()
  hasEditCommentPermission: boolean;

  @Prop()
  hasEditRestrictCommentPermission: boolean;

  @Prop()
  hasEditNextMessagePermission: boolean;

  @Prop()
  commentLabel: string;

  @Prop({ default: false })
  isCommentEnable: boolean;

  @Prop()
  restrictCommentLabel: string;

  @Prop({ default: false })
  isRestrictCommentEnable: boolean;

  @Prop()
  nextMessageLabel: string;

  @Prop({ default: false })
  isNextMessageEnable: boolean;

  @Prop({ default: false })
  isCommentConflicted: boolean;

  @Prop({ default: false })
  isNextMessageConflicted: boolean;

  @Prop({ default: false })
  isRestrictCommentConflicted: boolean;

  @Prop()
  showCommentDialog: (source: string, title: string, write: (text: string) => void) => Promise<void>;

  @Prop()
  showCommentDialogWithCommentTab: (source: string, title: string, write: (text: string) => void, label: string) => Promise<void>;

  @Emit()
  conflictResolved(kind: ReceptionCommentKinds, confirmedComment: ReceptionComment): void {}

  get detailId(): number {
    return this.readPropertyOrDefault(s => s.id, null);
  }

  get commentType(): string {
    return ReceptionCommentKindsName.getTypeName(ReceptionCommentKinds.Comment);
  }

  get restrictCommentType(): string {
    return ReceptionCommentKindsName.getTypeName(ReceptionCommentKinds.Restrict);
  }

  get nextMessageCommentType(): string {
    return ReceptionCommentKindsName.getTypeName(ReceptionCommentKinds.NextMessage);
  }

  get comment(): ReceptionComment {
    return this.isRegistered 
    ? this.comments.length < 1 ? this.getDefaultComment() : this.comments[0]
    : this.readPropertyOrDefault(s => s.comment, null);
  }

  set comment(value: ReceptionComment) {
    if (this.isRegistered) {
      this.writePropertyWhenValid(s => {
        s.editComment = value;
        s.commentSet.comments = new Array(value);
      });
    } else {
      this.writePropertyWhenValid(s => s.comment = value);
    }
  }

  get restrictComment(): ReceptionComment {
    return this.isRegistered
    ? this.restrictComments.length < 1 ? this.getDefaultComment() : this.restrictComments[0]
    : this.readPropertyOrDefault(s => s.restrictComment, null);
  }

  set restrictComment(value: ReceptionComment) {
    if (this.isRegistered) {
      this.writePropertyWhenValid(s => {
        s.editRestrictComment = value;
        s.commentSet.restrictComments = new Array(value);
      });
    } else {
      this.writePropertyWhenValid(s => s.restrictComment = value);
    }
  }

  get nextMessage(): ReceptionComment {
    return this.isRegistered
    ? this.nextMessages.length < 1 ? this.getDefaultComment() : this.nextMessages[0]
    : this.readPropertyOrDefault(s => s.nextMessage, null);
  }

  set nextMessage(value: ReceptionComment) {
    if (this.isRegistered) {
      this.writePropertyWhenValid(s => {
        s.editNextMessage = value;
        s.commentSet.nextMessages = new Array(value);
      });
    } else {
      this.writePropertyWhenValid(s => s.nextMessage = value);
    }
  }

  private getDefaultComment(): ReceptionComment {
    const comment = new ReceptionComment();
    comment.isEditable = true;
    return comment;
  }

  get comments(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.comments
      : [];
  }

  get restrictComments(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.restrictComments
      : [];
  }

  get nextMessages(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.nextMessages
      : [];
  }

  get commentSet(): ReceptionCommentSet {
    return this.readPropertyOrDefault(s => s.commentSet, null);
  }

  get isCommentEditable(): boolean {
    // 未登録 or コメント入力権限がある
    return !this.isRegistered 
    || (this.hasEditCommentPermission && this.hasEnteredCommentEditable(this.comments));
  }

  get isRestrictCommentEditable(): boolean {
    // 未登録 or コメント入力権限がある
    return !this.isRegistered 
    || (this.hasEditRestrictCommentPermission && this.hasEnteredCommentEditable(this.restrictComments));
  }

  get isNextMessageEditable(): boolean {
    // 未登録 or コメント入力権限がある
    return !this.isRegistered 
    || (this.hasEditNextMessagePermission && this.hasEnteredCommentEditable(this.nextMessages));
  }

  private hasEnteredCommentEditable(comments: ReceptionComment[]): boolean {
    return comments.length === 0 || (comments.length === 1 && comments[0].isEditable);
  }

  onCommentConflictResolved(source: ReceptionComment): void {
    // 登録前にCommentIdとArchiveIdで競合をチェックしているため更新
    this.comment.id = source.deleted ? null : source.id;
    this.comment.archiveId = source.deleted ? null : source.archiveId;
    this.conflictResolved(ReceptionCommentKinds.Comment, source);
  }

  onRestrictCommentConflictResolved(source: ReceptionComment): void {
    // 登録前にCommentIdとArchiveIdで競合をチェックしているため更新
    this.restrictComment.id = source.deleted ? null : source.id;
    this.restrictComment.archiveId = source.deleted ? null : source.archiveId;
    this.conflictResolved(ReceptionCommentKinds.Restrict, source);
  }

  onNextMessageConflictResolved(source: ReceptionComment): void {
    // 登録前にCommentIdとArchiveIdで競合をチェックしているため更新
    this.nextMessage.id = source.deleted ? null : source.id;
    this.nextMessage.archiveId = source.deleted ? null : source.archiveId;
    this.conflictResolved(ReceptionCommentKinds.NextMessage, source);
  }
}
